import { lory } from 'lory.js';
import { on } from 'delegated-events';
import helpers from './helpers.js';

/*
===========================================
Media Carousel
===========================================
*/
export default (function () {
  return {
    init() {
      function createNav(slider) {
        const count = slider.querySelectorAll('.slide').length;
        let html = '';
        for (let i = 0; i < count; i++) {
          html += `<button class="slider__nav-item js-slider-nav-item">${i + 1}</button>`;
        }
        slider.querySelector('.js-slider-nav').innerHTML = html;

        const dotContainer = slider.querySelector('.js-slider-nav');

        for (let i = 0; i < count; i++) {
          slider.querySelector('.js-slider-nav').childNodes[i].addEventListener('click', (e) => {
            e.preventDefault();
            slider.sliderInstance.slideTo(Array.prototype.indexOf.call(dotContainer.childNodes, e.target));
          });
        }
      }

      function updateNav(index, slider) {
        const dots = slider.querySelectorAll('.js-slider-nav .js-slider-nav-item');
        helpers.removeClass(dots, 'is-active');
        helpers.addClass(dots[index - 1], 'is-active');
      }

      const setFocus = (index, slider) => {
        const slides = slider.querySelectorAll('.slide');
        const currentSlide = slider.querySelector('.slide.active');

        helpers.addClass(slides, 'no-focus');
        helpers.setAttributes(slides, { tabIndex: '-1' });
        helpers.setAttributes(slider.querySelectorAll('.slide a'), { tabIndex: '-1' });

        helpers.removeClass(currentSlide, 'no-focus');
        helpers.removeAttribute(currentSlide, 'tabIndex');
        helpers.removeAttribute(currentSlide.querySelectorAll('a'), 'tabIndex');
      };

      const sliders = document.querySelectorAll('.js-slider');

      helpers.forEach(sliders, (i, el) => {
        const slider = el;
        const slides = slider.querySelectorAll('.slide');
        const dataSpeed = parseInt(slider.getAttribute('data-speed'), 0);
        const slideSpeed = Number.isNaN(dataSpeed) ? 300 : dataSpeed;
        const dataDelay = parseInt(el.getAttribute('data-delay'), 0);
        const slideDelay = Number.isNaN(dataDelay) ? 6000 : dataDelay;
        const motionQuery = matchMedia('(prefers-reduced-motion)').matches;
        const autoplay = slider.hasAttribute('data-autoplay') && !motionQuery;

        let stop = false;
        // const frameCount = 0;
        let fpsInterval; let startTime; let now; let then; let elapsed;

        if (slides.length === 1) {
          el.querySelector('.slider__controls').classList.add('u-hide');
          const currentSlide = slides[0];
          const caption = currentSlide.getAttribute('data-caption');
          if (caption == null || caption.trim() === '') {
            const bar = el.querySelector('.slider__bar');
            if (bar != null) bar.classList.add('u-hide');
          }
          return;
        }

        // try and stop jumping when you swipe
        el.style['touch-action'] = 'pan-y';
        el.style['user-select'] = 'none';
        el.style['-webkit-user-drag'] = 'none';

        helpers.forEach(slides, (index, slide) => {
          const els = slide.querySelectorAll('.slide__progress-left, .slide__progress-right');
          helpers.setStyle(els, 'transition-duration', `${slideDelay}ms`);
        });

        slider.addEventListener('after.lory.slide', (e) => {
          const index = e.detail.currentSlide;
          const currentSlide = slides[index - 1];
          updateNav(index, el);
          setFocus(index, el);
        });

        slider.addEventListener('before.lory.init', (e) => {
          const currentSlide = slides[0];
          createNav(el);
          updateNav(1, el);
        });

        slider.addEventListener('after.lory.init', (e) => {
          setFocus(1, el);
        });

        const carousel = lory(slider, {
          classNameFrame: 'js-slider-frame',
          classNameSlideContainer: 'js-slider-slides',
          classNamePrevCtrl: 'js-slider-prev',
          classNameNextCtrl: 'js-slider-next',
          infinite: 1,
          slideSpeed,
        });

        el.sliderInstance = carousel;

        // autoplay
        // animate (autoplay)
        function animate() {
          requestAnimationFrame(animate);

          now = Date.now();
          elapsed = now - then;

          if (elapsed > fpsInterval && !stop) {
            then = now - (elapsed % fpsInterval);
            carousel.next();
          }
        }

        // begin animation (autoplay)
        function startAnimating(fps) {
          fpsInterval = fps;
          then = Date.now();
          startTime = then;
          animate();
        }

        // reset timer
        function resetTimer() {
          now = Date.now();
          elapsed = now - then;
          then = now - (elapsed % fpsInterval);
        }

        function startAutoplay() {
          stop = false;
          startAnimating(slideDelay);
          slider.classList.add('is-autoplaying');
        }

        function stopAutoplay() {
          stop = true;
          slider.classList.remove('is-autoplaying');
        }

        if (autoplay) {
          // start the animation process with seed time
          startAutoplay();

          slider.addEventListener('click', (e) => {
            if (e.target && e.target.matches('.js-slider-next, .js-slider-prev, .js-slider-nav-item')) {
              stopAutoplay();
            }
          });

          slider.addEventListener('on.lory.touchend', (e) => {
            stopAutoplay();
          });
        }
      });
    },
  };
}());
